import Text from 'components/Text/Text';
import React, { useRef } from 'react';
import { DropdownMenu } from './components/DropdownMenu';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import style from './SortBy.module.scss';

export const SortBy: React.FC = () => {
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<>
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Dropdown
				className={style.container}
				overlay={<DropdownMenu />}
				trigger={['click']}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placement="bottomRight">
				<a className="ant-dropdown-link" onClick={(e) => e.preventDefault()} data-test="SortBy">
					<Text translationNameSpace="listing" translationKey="sortByLabel" theme="neutralLight" />
					<DownOutlined className={style.iconDropdown} />
				</a>
			</Dropdown>
		</>
	);
};
